import styled from 'styled-components';
import {CSS_CONSTANTS} from '../../css_variables';

export const TimeManagementSection = styled.div`
	margin-bottom: 40px;
`;

export const TimeFeatureToggleSection = styled.div`
	width: 566px;
	border-width: 1px 0 0;
	border-style: solid;
	border-color: ${CSS_CONSTANTS.v2_border_gray};
	padding: 24px 0;
	margin: 0 24px;
	&:last-child {
		border-bottom-width: 1px;
	}
`;

export const FeatureTitleToggle = styled.div`
	display: flex;
	margin-bottom: 16px;
`;

export const SwitchWrapper = styled.div`
	margin-right: 16px;
`;

export const TimeSubtitle = styled.span`
	font-size: 13px;
	width: 450px;
	color: ${CSS_CONSTANTS.v2_text_light_gray};
	a {
		color: ${CSS_CONSTANTS.link_text_color};
		cursor: pointer;
	}
`;

export const TimeTitle = styled.span`
	font-size: 13px;
	font-weight: 500;
	color: ${CSS_CONSTANTS.v2_text_gray};
`;
